const ASSET = (p) =>
    `https://customer-assets-m6fa6gv7.emergentagent.net/job_585500c5-b69d-4580-bd04-9f02502d3ba0/artifacts/${p}`;

// Local product images (served from /images/ via Cloudflare assets)
const LOCAL = (p) => `/images/${p}`;

export const IMAGES = {
    // Showcase gallery — final image/web (6 images, 1600x2000, 4:5)
    creamWorn: LOCAL("web-cream-1.png"),
    creamDetail: LOCAL("web-cream-2.png"),
    whiteWorn: LOCAL("web-white-1.png"),
    whiteDetail: LOCAL("web-white-2.png"),
    blackWorn: LOCAL("web-black-1.png"),
    blackDetail: LOCAL("web-black-2.png"),
    // OrderForm product select — only photo (3 images, 1122x1402, 4:5)
    creamSelect: LOCAL("cream-1.png"),
    whiteSelect: LOCAL("white-1.png"),
    blackSelect: LOCAL("black-1.png"),
};

// Showcase gallery: main image + thumbnails (ecommerce storefront style)
export const GALLERY = [
    { id: "cream-1", label: "ক্রিম — সামনে", src: IMAGES.creamWorn, color: "cream" },
    { id: "cream-2", label: "ক্রিম — ডিটেইল", src: IMAGES.creamDetail, color: "cream" },
    { id: "white-1", label: "সাদা — সামনে", src: IMAGES.whiteWorn, color: "white" },
    { id: "white-2", label: "সাদা — ডিটেইল", src: IMAGES.whiteDetail, color: "white" },
    { id: "black-1", label: "কালো — সামনে", src: IMAGES.blackWorn, color: "black" },
    { id: "black-2", label: "কালো — ডিটেইল", src: IMAGES.blackDetail, color: "black" },
];

export const COLORS = [
    { id: "cream", name: "ক্রিম", hex: "#F3EBDD", ring: "#C9B896", img: IMAGES.creamSelect, detail: IMAGES.creamSelect },
    { id: "white", name: "সাদা", hex: "#FFFFFF", ring: "#B9B6B0", img: IMAGES.whiteSelect, detail: IMAGES.whiteSelect },
    { id: "black", name: "কালো", hex: "#1F1F1F", ring: "#444444", img: IMAGES.blackSelect, detail: IMAGES.blackSelect },
];

export const SIZES = [
    { id: "40", label: "40 (M)" },
    { id: "42", label: "42 (L)" },
    { id: "44", label: "44 (XL)" },
    { id: "46", label: "46 (XXL)" },
];

// ─── WooCommerce product/variation mapping (verified) ───
export const WC_PRODUCT_IDS = { cream: 11688, white: 11489, black: 11517 };
export const WC_VARIATION_IDS = {
    white: { "40": 11491, "42": 11492, "44": 11493, "46": 11494 },
    cream: { "40": 11694, "42": 11695, "44": 11696, "46": 11697 },
    black: { "40": 11780, "42": 11781, "44": 11782, "46": 11783 },
};
export const WC_VARIATION_SKUS = {
    white: { "40": "White_Khadi_40", "42": "White_Khadi_42", "44": "White_Khadi_44", "46": "White_Khadi_46" },
    cream: { "40": "Cream_Khadi_40", "42": "Cream_Khadi_42", "44": "Cream_Khadi_44", "46": "Cream_Khadi_46" },
    black: { "40": "Black_Khadi_40", "42": "Black_Khadi_42", "44": "Black_Khadi_44", "46": "Black_Khadi_46" },
};

/** Build Meta contents[] array with WC product/variation IDs + attributes. */
export function metaContents(lines) {
    return lines.map((l) => ({
        id: String(WC_PRODUCT_IDS[l.color] || "khadi-punjabi"),
        quantity: l.qty,
        item_price: 900,
        // Attributes/variation info (Meta custom fields)
        content_name: `খাদি পাঞ্জাবি — ${colorName(l.color)}`,
        content_category: "পাঞ্জাবি",
        variation_id: WC_VARIATION_IDS[l.color]?.[l.size] || null,
        sku: WC_VARIATION_SKUS[l.color]?.[l.size] || null,
        color: colorName(l.color),
        size: l.size,
    }));
}

/** Build Meta content_ids[] from WC product IDs (unique). */
export function metaContentIds(lines) {
    const ids = lines.map((l) => String(WC_PRODUCT_IDS[l.color] || "khadi-punjabi"));
    return [...new Set(ids)];
}

export const PACKAGES = [
    {
        id: "single", qty: 1, title: "১টি পাঞ্জাবি", subtitle: "যেকোনো ১টি পছন্দসই রং",
        price: 900, regular: 1300, savings: "৳৪০০ ছাড়", delivery: "ডেলিভারি চার্জ প্রযোজ্য",
        perItem: true, badge: null,
    },
    {
        id: "double", qty: 2, title: "২টি পাঞ্জাবি", subtitle: "ভিন্ন ভিন্ন ২টি রং বেছে নিন",
        price: 1700, regular: 2600, savings: "৳৯০০ ছাড়", delivery: "ডেলিভারি চার্জ প্রযোজ্য",
        badge: "সর্বাধিক জনপ্রিয়",
    },
    {
        id: "triple", qty: 3, title: "৩টি পাঞ্জাবি", subtitle: "ক্রিম, সাদা ও কালো — ৩টি রং",
        price: 2500, regular: 3900, savings: "৳১,৪০০ ছাড় + ফ্রি ডেলিভারি", delivery: "সম্পূর্ণ ফ্রি ডেলিভারি",
        badge: "সেরা ডিল",
    },
];

const BN = "০১২৩৪৫৬৭৮৯";
export const bn = (v) => String(v).replace(/\d/g, (d) => BN[d]);
export const bdt = (n) => "৳" + bn(Number(n).toLocaleString("en-IN"));
export const colorName = (id) => COLORS.find((c) => c.id === id)?.name || "";

export function computeTotals(lines, zone) {
    const qty = lines.reduce((a, l) => a + l.qty, 0);
    let subtotal = 900 * qty, free = false, offer = null;
    if (qty >= 3) {
        subtotal = 2500 + 900 * (qty - 3); free = true; offer = "৩টি পাঞ্জাবির প্যাকেজ অফার প্রয়োগ হয়েছে — ডেলিভারি ফ্রি";
    } else if (qty === 2) {
        subtotal = 1700; offer = "২টি পাঞ্জাবির প্যাকেজ অফার প্রয়োগ হয়েছে";
    }
    const delivery = qty === 0 ? null : free ? 0 : zone === "inside_dhaka" ? 70 : 130;
    return { subtotal, delivery, total: delivery === null ? null : subtotal + delivery, qty, free, offer };
}

export const PHONE_RE = /^01[3-9]\d{8}$/;
export const normalizePhone = (raw) => {
    let p = String(raw || "").replace(/[\s\-()]/g, "");
    if (p.startsWith("+880")) p = "0" + p.slice(4);
    else if (p.startsWith("880")) p = "0" + p.slice(3);
    return p;
};
